/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createPresets = createPresetsFactory();
export const generatedPresets = createPresets([
    {
        name: 'Default',
        description: 'Default preset',
        rootEntityType: 'Table',
        initialDomainEntities: [
            {
                id: 'Table-1',
                type: 'Table',
                topId: 'RectangleTop-1',
                baseStyleId: 'BrewerBase-1',
                benchId: 'BenchBasic-1',
                baseType: 'Pedestal',
                woodSpecies: 'Hickory',
                sheen: 'Flat',
                seatingType: 'NoSeating',
                seatingAmount: 0
            },
            {
                id: 'RectangleTop-1',
                type: 'RectangleTop',
                length: 84,
                width: 42,
                thickness: 1.75,
                thicknessType: 'Standard',
                edgeStyle: 'Clean',
                distressLevel: 'Clean',
                finish: 'NaturalTone',
                withGrooves: false,
                withCornerRadius: false,
                leafType: 'NoLeaf',
                leafAmount: 0,
                apronId: 'ApronNone-1'
            },
            {
                id: 'BrewerBase-1',
                type: 'BrewerBase',
                hasCrossbrace: false,
                finish: 'EbonyTone'
            },
            {
                id: 'ApronNone-1',
                type: 'ApronNone'
            },
            {
                id: 'BenchBasic-1',
                type: 'BenchBasic'
            }
        ]
    }
]);

//# sourceMappingURL=presets.js.map